module.exports = __webpack_public_path__ + "static/media/hi-IN.008cc6c6.md";